document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initPopup();
  initStats();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-mt-delay') || '0', 10);
          setTimeout(function () { el.classList.add('mt-visible'); }, delay);
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el, i) {
    if (!el.hasAttribute('data-mt-delay')) {
      el.setAttribute('data-mt-delay', String((i % 4) * 90));
    }
    observer.observe(el);
  });
}

function initPopup() {
  var overlay = document.querySelector('[data-mt-popup]');
  if (!overlay) return;
  // En el carrito y el pago el popup no sale: tapa justo el paso en el que la persona va a comprar.
  if (/^\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return;
  var storageKey = 'mt-popup-cerrado';
  var delay = parseInt(overlay.getAttribute('data-mt-delay') || '4000', 10);
  var frequencyDays = parseInt(overlay.getAttribute('data-mt-frequencia') || '7', 10);

  try {
    var last = localStorage.getItem(storageKey);
    if (last) {
      var elapsedDays = (Date.now() - parseInt(last, 10)) / (1000 * 60 * 60 * 24);
      if (elapsedDays < frequencyDays) return;
    }
  } catch (e) {}

  function abrir() {
    overlay.classList.add('mt-popup-visible');
  }
  function cerrar() {
    overlay.classList.remove('mt-popup-visible');
    try { localStorage.setItem(storageKey, String(Date.now())); } catch (e) {}
  }

  // En las fichas de producto el popup no tapa la compra: solo sale (en escritorio) cuando
  // la persona va a abandonar la página. En el resto de páginas se mantiene el retraso normal.
  if (/^\/products\//.test(location.pathname)) {
    var salida = function (e) {
      if (e.clientY <= 0 && !e.relatedTarget) {
        document.removeEventListener('mouseout', salida);
        abrir();
      }
    };
    document.addEventListener('mouseout', salida);
  } else {
    setTimeout(abrir, delay);
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) cerrar();
  });
  var closeBtn = overlay.querySelector('[data-mt-popup-close]');
  if (closeBtn) closeBtn.addEventListener('click', cerrar);
  var noThanks = overlay.querySelector('[data-mt-popup-skip]');
  if (noThanks) noThanks.addEventListener('click', cerrar);

  var form = overlay.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (e) {}
    });
  }
}

function initStats() {
  var stats = document.querySelectorAll('[data-mt-count]');
  if (!stats.length) return;
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-mt-count'));
        var suffix = el.getAttribute('data-mt-suffix') || '';
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        observer.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );
  stats.forEach(function (el) { observer.observe(el); });
}
